import React, { useState } from 'react'
import { triggerClevertap, httpAxios, getCommonClevertapParams } from 'AccountsUtils'
import { GET_CALL } from 'AccountsConstants/api_endpoints'

const LinkInput = ({
  liClass,
  linkClass,
  link,
  Icon,
  title,
  text = '',
  initialValue,
  callbackFn = null,
  note,
  inputType = 'normal',
  validator,
  fieldName,
  isPWA,
  tripId
}) => {
  const cleverTapData = {
    ...getCommonClevertapParams(),
    event_type: text.toLowerCase().replace(' ', '_'),
    trip_ID: tripId
  }
  const defaultValue = initialValue
  const [inputView, changeView] = useState(false)
  const [inputValue, updateValue] = useState(defaultValue)
  const [inputState, updateState] = useState('dormant')
  let btnClass = 'bg-blue br-2 bn c-white px-4 cursorPoi py-2 fs-13 ba bc-secondary-500'
  const sendRequest = (url, value, stateFn, valFn, defVal, viewFn) => {
    stateFn('loading')
    httpAxios(`${url}${value}`, GET_CALL, '')
      .then(() => {
        stateFn('success')
        valFn(defVal)
        viewFn(false)
        triggerClevertap('Account', cleverTapData)
      })
      .catch(err => {
        stateFn('error')
        console.error(err)
        if (err && err.response && err.response.status === 401) {
          console.error('auth error')
        }
      })
  }
  if (inputState === 'loading') {
    btnClass += ' loading'
  }

  const onSend = e => {
    e.stopPropagation()
    e.preventDefault()
    if (validator(inputValue)) {
      if (!callbackFn) {
        sendRequest(link, inputValue, updateState, updateValue, defaultValue, changeView, {
          ...cleverTapData,
          event_type: `${cleverTapData.event_type}_success_shown`
        })
        triggerClevertap('Account', {
          ...cleverTapData,
          event_type: `${cleverTapData.event_type}_send_clicked`
        })
      } else if (typeof callbackFn === 'function') {
        callbackFn(inputValue)
      }
    } else {
      updateState('invalid')
    }
  }

  const onBlur = e => {
    e.stopPropagation()
    e.preventDefault()
    updateState(!validator(inputValue) ? 'invalid' : 'dormant')
  }
  const onInputChange = e => {
    e.stopPropagation()
    e.preventDefault()
    updateValue(e.target.value)
  }
  const toggleView = () => {
    if (inputType === 'normal') {
      changeView(!inputView)
    } else if (typeof callbackFn === 'function') {
      callbackFn(inputValue)
    }
    triggerClevertap('Account', {
      ...cleverTapData,
      event_type: `${cleverTapData.event_type}_clicked`
    })
  }
  return (
    <li className={`${liClass || ''}`}>
      <div className="flex-1">
        <If condition={text}>
          <div className="flex flex-middle">
            <If condition={Icon}>{Icon}</If>
            <a
              className={`fs-caption-2 c-blue cursorPoi pl-1 pr-1 ${linkClass || ''}`}
              title={title}
              onClick={toggleView}
            >
              {text}
            </a>
          </div>
        </If>
        <If condition={(inputView && inputType === 'normal') || inputType === 'input_only'}>
          <div className="flex flex-column">
            <div className="flex flex-top my-2">
              <input
                className={`mr-1 ba bc-neutral-300 p-2 flex-1 ${!isPWA ? 'width-20' : ''}`}
                value={inputValue}
                onChange={onInputChange}
                onBlur={onBlur}
              />
              <button type="button" className={btnClass} onClick={onSend}>
                Send
              </button>
            </div>
            <If condition={inputState === 'success'}>
              <div
                className="fs-12 new-banner nmt-2 p-1 px-2 us-text"
                onClick={() => updateState('dormant')}
              >
                Sent successfully
              </div>
            </If>
            <If condition={inputState === 'invalid'}>
              <div
                className="fs-12 new-banner nmt-2 p-1 px-2 us-text"
                onClick={() => updateState('dormant')}
              >
                Invalid {fieldName}
              </div>
            </If>
            <If condition={inputState === 'error'}>
              <div
                className="fs-12 new-banner nmt-2 p-1 px-2 us-text"
                onClick={() => updateState('dormant')}
              >
                Could not send
              </div>
            </If>
            <If condition={inputState !== 'dormant'}>
              <div style={{ display: 'none' }}>
                {setTimeout(() => {
                  updateState('dormant')
                }, 10000)}
              </div>
            </If>
          </div>
        </If>
        <If condition={note}>
          <div className="pb-2 fs-11 pt-1">{note}</div>
        </If>
      </div>
    </li>
  )
}

export default LinkInput
